import {GetCookieInfo} from "./CookieManager";
import {GetEnumValueName} from "./EnumHelper";
import {DownloadFileFromBlob} from "./FileDownloader";

export const GenerateTransferConfirmation = async (transferId, snackbar, setSnackbar) => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(
            `${process.env.REACT_APP_REPORTING_URL}/transfer-confirmation`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + tokenCookie.value,
                },
                body: JSON.stringify({
                    transferId: transferId
                }),
            }
        );
        if (response.ok) {
            let fileName = GetEnumValueName('reportType', 5) + '.pdf';
            await DownloadFileFromBlob(response, fileName);
            console.log('Report generating successfully.');
        } else {
            console.log('Report generating failed.');
            if (snackbar && setSnackbar) {
                response.json().then((json) => {
                    setSnackbar({ ...snackbar, open: true, message: json.errorMessage})
                });
            }
        }
    } catch (error) {
        console.log('An error occurred:', error);
    }
};

export const GenerateTradeConfirmation = async (tradeId, snackbar, setSnackbar) => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(
            `${process.env.REACT_APP_REPORTING_URL}/trade-confirmation`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + tokenCookie.value,
                },
                body: JSON.stringify({
                    tradeId: tradeId
                }),
            }
        );
        if (response.ok) {
            let fileName = GetEnumValueName('reportType', 4) + '.pdf';
            await DownloadFileFromBlob(response, fileName);
            console.log('Report generating successfully.');
        } else {
            console.log('Report generating failed.');

            if (snackbar && setSnackbar) {
                response.json().then((json) => {
                    setSnackbar({ ...snackbar, open: true, message: json.errorMessage})
                });
            }
        }
    } catch (error) {
        console.log('An error occurred:', error);
    }
};